import React from "react";
import { useSelector } from "react-redux";
import { useFormattedMessage, useSideModalScrollToTop } from "hooks";
import { selectSparkasseUserDetails } from "store/user/account/selectors";

const messages = {
    accountDetails: "account_details",
    personalIdentificationNumber: "personal_identification_number",
    blz: "blz",
    disconnect: "disconnect",
};

const AccountDetails = ({ backSlideEffect, setBackSlideEffect, setStep }) => {
    useSideModalScrollToTop();
    const { formatMessage } = useFormattedMessage();
    const sparkasseUserDetails = useSelector(selectSparkasseUserDetails);

    const accountInfo = sparkasseUserDetails
        ? [
              { label: messages.personalIdentificationNumber, value: sparkasseUserDetails.personen_nummer || "" },
              { label: messages.blz, value: sparkasseUserDetails.blz || "" },
          ]
        : [];

    const handleDisconnect = () => {
        setBackSlideEffect("step-slide-left");
        setStep("confirmation");
    };

    return (
        <div className={`link-sparkasse-account-detail-screen p-6 ${backSlideEffect}`}>
            <h5 className="mt-0">{formatMessage(messages.accountDetails)}</h5>

            <div className="border-1 border-radius p-5 mb-5">
                {accountInfo.length > 0 ? (
                    accountInfo.map(({ label, value }) => (
                        <div key={label} className="mb-5 last:mb-0">
                            <span className="text-14 d-block mb-2 secondary-light-color">{formatMessage(label)}</span>
                            <span className="text-14 d-block">{value}</span>
                        </div>
                    ))
                ) : (
                    <div className="text-14 secondary-light-color">No account details available</div>
                )}
            </div>

            <button className="danger mw-100" onClick={handleDisconnect}>
                {formatMessage(messages.disconnect)}
            </button>
        </div>
    );
};

export default AccountDetails;
